import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../components/ReactSelect';
import { bin2hex, data, dataMysql, extract, pontoVirgula } from '../../../util/util';
import { toast } from 'react-toastify';
import ItemChecklist from '../../../components/ItemChecklist';
import { FinField } from '../../../components/FinField';
import '../../../css/financeiro-parcela-pagar.css';


export default function CadastroEventoChecklist() {
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    const params = new URLSearchParams(window.location.search);
    const idEvento = params.get('idEvento');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [reload, setReload] = useState(1);
    const history = useHistory();

    const validar = () => {
        var evento = document.querySelector("#evento");
        if (dados.evento === undefined || dados.evento === null) {
            toast.error('É necessário selecionar o evento');
            setTimeout(() => {
                evento.focus();
            }, 500);
            return false;
        }

        var modelo = document.querySelector("#modelo");
        if (dados.modelo === undefined || dados.modelo === null) {
            toast.error('É necessário selecionar o modelo de checklist');
            setTimeout(() => {
                modelo.focus();
            }, 500);
            return false;
        }
        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false;
        }
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        api({
            method: 'post',
            action: '/eventoChecklist',
            token: token,
            data: {
                ...dados,
            }
        })
            .then(response => {
                toast.success("Dados salvos com sucesso!");
                history.push("/alterarEventoChecklist/" + response.data.data.id);
            })
            .catch(function (error) {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => {
        if (idEvento) {
            api({
                method: 'get',
                action: '/evento/' + idEvento,
                token: token
            })
                .then(response => {
                    const evento = response.data.data;
                    let label = evento.nome;
                    if (evento.identificacao) {
                        label = evento.identificacao + " - " + label;
                    }
                    if (evento.cliente) {
                        label = label + ' - ' + evento.cliente.nome;
                    }
                    label = evento.codigo + " - " + label;

                    setDados({
                        ...dados,
                        evento: evento.id,
                        nomeEvento: label
                    });
                })
                .catch(err => {
                    toast.error('Erro ao carregar evento');
                });
        }
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Novo Checklist</h1></div>
                </div>
                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            {idEvento && (
                                <FinField label="Evento">
                                    <input
                                        type="text"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14, backgroundColor: '#f0f0f0' }}
                                        value={dados.nomeEvento || ''}
                                        disabled
                                    />
                                </FinField>
                            )}
                            {!idEvento && (
                                <FinField label="Evento">
                                    <ReactSelect
                                        id="evento"
                                        value={{ value: dados.evento ?? "", label: dados.nomeEvento ?? "" }}
                                        onChange={(e) => {
                                            setDados({ ...dados, evento: e.value, nomeEvento: e.label });
                                        }}
                                        loadOptions={(input) => {
                                            return api({
                                                method: 'get',
                                                action: '/evento',
                                                token: token,
                                                params: {
                                                    nome: input,
                                                    situacao: ["ativo", "fechado", "cancelado"]
                                                }
                                            })
                                                .then(response => {
                                                    let options = response.data.data.map((registro) => {
                                                        var label = registro.nome;
                                                        if (registro.identificacao) {
                                                            label = registro.identificacao + " - " + label;
                                                        }
                                                        if (registro.cliente) {
                                                            label = label + ' - ' + registro.cliente.nome;
                                                        }
                                                        label = registro.codigo + " - " + label;
                                                        return { value: registro.id, label: label };
                                                    });
                                                    return options;
                                                })
                                                .catch(function (error) {
                                                    //console.log(error);
                                                });
                                        }}
                                    />
                                </FinField>
                            )}
                            <FinField label="Modelo">
                                <ReactSelect
                                    id="modelo"
                                    value={{ value: dados.modelo ?? "", label: dados.nomeModelo ?? "" }}
                                    onChange={(e) => {
                                        dados.modelo = e.value;
                                        dados.nomeModelo = e.label;
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/eventoChecklistModelo',
                                            token: token,
                                            params: { nome: input }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.codigo + "-" + registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Iniciar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
